const BRAND_CURATION_TASK_PROBLEM_REASON = {
  MISC: {
    label: 'Misc',
    value: 'MISC',
  },
  ERROR: {
    label: 'Error',
    value: 'ERROR',
  },
}

export default BRAND_CURATION_TASK_PROBLEM_REASON
